/**
 * `router/common.js`
 * - 全ページ共通のスクリプト

 * - barbaのオンオフに関わらず実行が必要な処理だけまとめる
 * - barbaがオンの時だけ必要な共通処理はbarbaHooksに直接指定して管理すること
 *
 * 使用方法:
 * - import {initCommonRoutes} from "../router/common.js";
 */


import {config} from "../config.js";
import {initActionHandlers} from "../modules/actionHandler.js";
import TextSplit from "../modules/textSplit.js";
import {manageBadgeReCAPTCHA} from "../core/wordpress/mwwpform/recaptchaBadgeManager.js";
import {barbaResetScrollPosition} from "../core/barba/utils/barbaResetScrollPosition.js";
import {manageNegativeClass, manageInversionClass} from "../utils/intersection.js";


const routeCommon = {

  async once(data) {
    barbaResetScrollPosition(data); // 初回ロード時のスクロール位置調整
  },

  before(data) {
    console.log('🔄 Executing routeCommon.before');
    manageNegativeClass.stop();
    manageInversionClass.stop();
  },

  beforeLeave(data) {
    console.log('🔄 Executing routeCommon.beforeLeave');
  },

  leave(data) {
    console.log('🔄 Executing routeCommon.leave');
  },

  afterLeave(data) {
    console.log('🔄 Executing routeCommon.afterLeave');
  },

  beforeEnter(data) {
    console.log('🔄 Executing routeCommon.beforeEnter');
  },

  enter(data) {
    console.log('🔄 Executing routeCommon.enter');
  },

  async afterEnter(data) {
    console.log('🔄 Executing routeCommon.afterEnter');

    // GSAP
    if (config.useGsap) {
      console.log("🧚‍♀️ Initializing gsap...");
      await import(/* webpackChunkName: "gsap" */ "../modules/gsap/gsap.js");
    }

    // 他のスクリプトを並列でロード（完了までbarbaを待つ必要がある処理）
    const imports = [];

    // Swiper.js
    if (config.useSwiper) {
      imports.push(import(/* webpackChunkName: "swiper" */ "../modules/swiper/swiper.js").then((
        {
          initCardSwiper,
          initInterviewSwiper,
          initTickerSwiper,
          // initImageSwiper,
          // initImageSwiperThumb,
          // initParallaxImageSwiper,
        }) => {
        console.log("🖼️ Initializing Swiper...");
        initInterviewSwiper('.home_interview_swiper', data, {slidesPerView: 1.5673077, breakpoints: { 768: { slidesPerView: 3.92, } }}, false, true, false, true, );
        initTickerSwiper('.swiper-ticker', data, 3000, false);
        initTickerSwiper('.swiper-ticker-reverse', data, 3000, false);
        initTickerSwiper('.swiper-business-message-ticker', data, 3000, false);
        initTickerSwiper('.swiper-business-group-ticker', data, 3000, false);
        initCardSwiper('.swiper-cards', data, {speed: 1200});
        // initImageSwiper('.swiper-image', data, {speed: 1200});
        // initImageSwiperThumb(['.swiper-image-main', '.swiper-image-thumb'], data, {speed: 1200});
        // initParallaxImageSwiper('.swiper-parallax', data, {speed: 2000});
      }));
    }

    await Promise.allSettled(imports); // allだと一つでもエラーが出たら止まるのでallSettleを採用

    // その他の共通処理（完了までbarbaを待たなくてOKな処理）
    initActionHandlers(data);
    TextSplit.apply("[data-txt-anim~=split]");
    manageBadgeReCAPTCHA(data);
  },


  after(data) {
    console.log('🔄 Executing routeCommon.after');

    requestAnimationFrame(() => {
      setTimeout(() => {
        manageNegativeClass.start(".header", ".negative");
        manageInversionClass.start(".header", ".inversion");
      }, 10); // 遷移後の描画を待つために少し遅延させる
    });

    // GsapScrollTrigger
    if (config.useGsapScrollTrigger) {
      import(/* webpackChunkName: "gsapScrollTrigger" */ "../modules/gsap/gsapScrollTrigger.js").then((
        {
          initScrollTrigger
        }) => {
        initScrollTrigger(data);
      });
    }
  },

};


export default routeCommon;
